import { Steps } from "rsuite";
import "rsuite/Steps/styles/index.css";
import { useState, useEffect } from "react";
import { BookingStepsUpdateCard } from "./BookingStepsUpdateCard";
import "./css/custom-steps.css";
import { formatString } from "../../utility/api";
import { useTranslation } from "react-i18next";

const bookingSteps = {
  requested: 1,
  // accepted: 1,
  reserved: 2,
  //   reserveCompleted: 3, // New status for Reserve Completion
  dealClosed: 3,
  rejected: 4,
};

const BookingSteps = ({
  currentStatus,
  onUpdate,
  data,
  setData,
  isCancellation,
  setIsReject,
  isReject,
  loading,
  buttonLoading,
}) => {
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState(0);
  const [currentStepInfo, setCurrentStepInfo] = useState(0);
  const [selectedStep, setSelectedStep] = useState(null);

  useEffect(() => {
    if (bookingSteps[currentStatus] !== undefined) {
      setCurrentStep(bookingSteps[currentStatus]);
      setCurrentStepInfo(bookingSteps[currentStatus]);
    }
  }, [currentStatus]);

  const handleStepClick = (index) => {
    setCurrentStepInfo(index);
  };

  const isDealClosed = currentStatus == "dealClosed";

  const getStatusDescription = (status, additionalStatus) => {
    const statusHistory = data?.booking?.statusHistory;
    if (!statusHistory) return {
      status: "",
      data: isDealClosed 
        ? t('usedCars.bookingSteps.dealClosed')
        : t('usedCars.bookingSteps.notCompleted')
    };

    if (additionalStatus) {
      const matchingStatus = statusHistory.find(
        (ele) =>
          ele.status === status || ele.status === additionalStatus
      );
      return matchingStatus;
    }

    const matchingStatus = statusHistory.find(
      (ele) => ele.status === status
    );
    return matchingStatus || {
      status: "",
      data: isDealClosed 
        ? t('usedCars.bookingSteps.dealClosed')
        : t('usedCars.bookingSteps.notCompleted')
    };
  };

  const statusHistory = data?.booking?.statusHistory || [];

  const hasPaymentStatus = statusHistory.some(
    (ele) =>
      ele.status === "paymentRequested" || ele.status === "paymentCompleted"
  );

  const isPaymentCompleted = statusHistory.some(
    (ele) => ele.status === "paymentCompleted"
  );

  const isCancelledByUser = data?.booking?.status === "cancelled";

  return (
    <div className="flex gap-8 justify-around items-center min-h-[630px] max-h-[750px]">
      <div className="max-h-[65vh] overflow-auto no-scrollbar p-2">
        <Steps
          current={currentStep}
          vertical
          className="custom-step rs-theme-light"
        >
          <Steps.Item
            className="cursor-pointer"
            onClick={() => handleStepClick(0)}
            title={t('usedCars.bookingSteps.request')}
            description={getStatusDescription("Requested")?.data}
            status={
              currentStatus === "accepted" ||
              currentStatus === "reserved" ||
              currentStatus === "dealClosed" ||
              currentStatus === "rejected" ||
              currentStatus == "cancelled"
                ? "finish"
                : "wait"
            }
          />

          {/* <Steps.Item
            className="cursor-pointer"
            onClick={() => handleStepClick(1)}
            title={t('usedCars.bookingSteps.acceptance')}
            description={getStatusDescription("Accepted")?.data}
            status={
              getStatusDescription("Accepted").status == "Accepted" ||
              currentStatus == "dealClosed" ||
              currentStatus == "reserved"
                ? "finish"
                : "wait"
            }
          /> */}

          {/* {
          (data?.booking?.testDrive?.status == "rescheduleProposed" ||
            data?.booking?.testDrive?.status == "rescheduleConfirmed") && (
            <Steps.Item
              className="cursor-pointer"
              title={t('usedCars.bookingSteps.awaitingConfirmation')}
              description={data?.booking?.testDrive?.proposedDate}
              status={
                data?.booking?.testDrive?.status == "rescheduleConfirmed"
                  ? "finish"
                  : "wait"
              }
            />
          )} */}

          {!isCancelledByUser && data?.booking?.status != "rejected" && (
            <Steps.Item
              className="cursor-pointer"
              onClick={() => handleStepClick(2)}
              title={t('usedCars.bookingSteps.reservation')}
              description={getStatusDescription("Reserved")?.data}
              status={
                currentStatus == "dealClosed" || currentStatus == "reserved"
                  ? "finish"
                  : "wait"
              }
            />
          )}

          {!isCancelledByUser && data?.booking?.status == "reserved" && (
            <Steps.Item
              className="cursor-pointer"
              onClick={() => handleStepClick(6)}
              title={t('usedCars.bookingSteps.payment')}
              description={
                getStatusDescription("paymentRequested", "paymentCompleted")
                  ?.data
              }
              status={hasPaymentStatus ? "finish" : "wait"}
            />
          )}

          {hasPaymentStatus && (
            <Steps.Item
              className="cursor-pointer"
              title={t('usedCars.bookingSteps.paymentConfirmation')}
              description={
                isPaymentCompleted
                  ? t('usedCars.bookingSteps.paymentCompleted')
                  : t('usedCars.bookingSteps.paymentPending')
              }
              onClick={() => handleStepClick(5)}
              status={isPaymentCompleted ? "finish" : "wait"}
            />
          )}

          {!isCancelledByUser && data?.booking?.status != "rejected" && (
            <Steps.Item
              className="cursor-pointer"
              onClick={() => handleStepClick(3)}
              title={t('usedCars.bookingSteps.completion')}
              description={getStatusDescription("dealClosed")?.data}
              status={
                getStatusDescription("dealClosed").status == "dealClosed"
                  ? "finish"
                  : "wait"
              }
            />
          )}

          {currentStatus !== "dealClosed" &&
            !isCancelledByUser &&
            data?.booking?.status != "cancelled" && (
              <Steps.Item
                className="cursor-pointer"
                onClick={() => handleStepClick(4)}
                title={t('usedCars.bookingSteps.rejection')}
                description={getStatusDescription("Rejected")?.data}
                status={currentStatus === "rejected" ? "error" : "wait"}
              />
            )}

          {data?.booking?.status == "cancelled" && (
            <Steps.Item
              className="cursor-pointer"
              onClick={() => setSelectedStep("cancelled")}
              title={t('usedCars.bookingSteps.cancelled')}
              description={t('usedCars.bookingSteps.cancelledByUser')}
              status={data?.booking?.status == "cancelled" && "finish"}
            />
          )}
        </Steps>
      </div>
      <div>
        <div className="w-full bg-[#EDEDEDED]">
          {/* Dynamic rendering of the update card based on the current step */}
          {currentStepInfo === 0 && (
            <BookingStepsUpdateCard
              currentStepInfo={currentStepInfo}
              onUpdate={onUpdate}
              data={data}
              loading={loading}
            />
          )}
          {currentStepInfo === 1 && (
            <div>
              <h2 className="text-center text-lg p-2">Booking Acceptance</h2>
              <BookingStepsUpdateCard
                currentStepInfo={currentStepInfo}
                onUpdate={onUpdate}
                data={data}
                description={
                  (currentStatus == "accepted" ||
                    currentStatus == "reserved" ||
                    currentStatus == "dealClosed") &&
                  getStatusDescription("Accepted")
                }
                loading={loading}
              />
            </div>
          )}
          {currentStepInfo === 2 && (
            <div>
              <h2 className="text-center text-lg p-2">Reserve Status</h2>
              <BookingStepsUpdateCard
                onUpdate={onUpdate}
                data={data}
                currentStepInfo={currentStepInfo}
                description={
                  (currentStatus == "reserved" ||
                    currentStatus == "dealClosed") &&
                  getStatusDescription("Reserved")
                }
                loading={loading}
              />
            </div>
          )}
          {currentStepInfo === 3 && (
            <div>
              <h2 className="text-center text-lg p-2">Completion Status</h2>
              <BookingStepsUpdateCard
                onUpdate={onUpdate}
                data={data}
                currentStepInfo={currentStepInfo}
                description={
                  currentStatus == "dealClosed" &&
                  getStatusDescription("dealClosed")
                }
                isReject={isReject}
                setIsReject={setIsReject}
                setCurrentStepInfo={() => handleStepClick(4)}
                loading={loading}
              />
            </div>
          )}

          {currentStepInfo == 4 && (
            <div>
              <h2 className="text-center text-lg p-2">Rejection Status</h2>
              <BookingStepsUpdateCard
                onUpdate={onUpdate}
                data={data}
                currentStepInfo={currentStepInfo}
                setData={setData}
                loading={loading}
              />
            </div>
          )}

          {currentStepInfo == 5 && (
            <div>
              <h2 className="text-center text-lg p-2">Payment Status</h2>
              <BookingStepsUpdateCard
                onUpdate={onUpdate}
                data={data}
                currentStepInfo={currentStepInfo}
                setData={setData}
                loading={loading}
                buttonLoading={buttonLoading}
              />
            </div>
          )}

          {currentStepInfo == 6 && (
            <div>
              <h2 className="text-center text-lg p-2">Payment Status</h2>
              <BookingStepsUpdateCard
                onUpdate={onUpdate}
                data={data}
                currentStepInfo={currentStepInfo}
                setData={setData}
                loading={loading}
                buttonLoading={buttonLoading}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BookingSteps;
